import { css, keyframes } from "styled-components";

// The app's entrance on first load: the app bar and top bar contents paint
// in, once, when the real app is ready to show (an account with its tokens).
// The bars themselves don't move, they are always there.
//
// Marked once the top bar's paint in has ended, which only happens for what's
// on screen: while lazy chunks load, the app bar or top bar may be mounted
// hidden and run its effects well before it shows. Also marked when switching
// account (e.g. test mode) starts, so the remount after it doesn't replay it.
let presented = false;

export const isFirstAppPaint = () => !presented;

export const markAppPainted = () => {
    presented = true;
};

const paintIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
`;

// Fades an element in after --paint-index steps, so siblings paint in one
// after another. Only a "from" keyframe so elements end on their own styles.
export const paintInAnimation = css`
    animation: ${paintIn} 0.5s cubic-bezier(0.22, 1, 0.36, 1) backwards;
    animation-delay: calc(var(--paint-index, 0) * 50ms);

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;
